export default {
  install(Vue, options = {}) {
    Vue.filter("removeNum", (txt) => {
      txt = txt.trim();
      let arr = txt.split("、");
      if (arr.length > 1) {
        return arr.slice(1).join("、");
      } else {
        return arr[0];
      }
    });
  },
};
